<template>
  <v-container fluid>
    <v-row class="">
      <v-col xs6 class="">
        <v-text-field
          v-model="newCategory"
          label="Add new category"
          hint="min 2 characters required"
          class="pa-0 ma-0"
          color="#A0C548"
          density="compact"
          variant="underlined"
        ></v-text-field>
      </v-col>
      <v-col xs6>
        <v-btn
          color="rgba(165, 216, 103, 1)"
          class="elevation-0 font-weight-bold app-btn"
          :disabled="newCategory.length < 2"
          @click="addCategory"
          >Add</v-btn
        >
      </v-col>
    </v-row>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        fixed-header
        :loading="isloading"
        loading-text="Loading Categories... Please wait"
        no-data-text="No categories have been created"
        :items="allCategories"
        :items-per-page="20"
        item-value="id"
        :header-props="{ sortIcon: '$sortarrowdown' }"
        :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
        class="elevation-1 users-table"
      >
        <template #progress>
          <v-progress-linear color="#592892" indeterminate></v-progress-linear>
        </template>

        <!-- 👇 Manual table header -->
        <template #headers>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-right">Count</th>
            <th class="text-right">Actions</th>
          </tr>
        </template>

        <template #item="{ item }">
          <tr>
            <!-- <td>
              <div v-if="showedit === item.id">
                <v-form v-model="isFormValid">
                  <v-text-field
                    v-model="item.name"
                    persistent-hint
                    hint="Edit category's name"
                    class="user-input"
                    color="#A0C548"
                    density="compact"
                    variant="underlined"
                    :loading="isediting"
                    v-on:keyup.native="editCat(item)"
                  />
                </v-form>
              </div>
              <div v-else>
                {{ item.name }}
              </div>
            </td> -->
            <td>
              <div v-if="showedit === item.id">
                <v-text-field
                  v-model="item.name"
                  hint="Edit category's name"
                  class="user-input"
                  color="#A0C548"
                  density="compact"
                  variant="underlined"
                  :loading="isediting"
                >
                  <template #append-inner>
                    <v-icon class="cursor-pointer" @click="editCat(item)">
                      check
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
              <div v-else>
                {{ item.name }}
              </div>
            </td>

            <td class="text-right">
              {{ sectionsAndUnitsUsingThisCat(item) }}
            </td>

            <td class="text-right">
              <div
                v-if="
                  isAuthenticated &&
                  checkAuthorization(['superAdmin']).length > 0 &&
                  !isHelpDesk
                "
                class="action-icons"
              >
                <v-icon
                  @click.native="
                    showedit = showedit === item.id ? null : item.id
                  "
                  class="mr-6"
                  >edit</v-icon
                >
                <v-icon @click.native="removeCategoryDialogInit(item)"
                  >delete_icon</v-icon
                >
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-dialog v-model="removeCategoryDialog" persistent max-width="500px">
      <v-card :class="[isDarkTheme ? 'app-dark' : 'app-light']">
        <v-card-title class="text-h6 pb-0 justify-center text-center"
          >Category Removal</v-card-title
        >
        <v-card-text class="pb-2 text-center"
          >Are you sure you want to remove <br />the category
          <em
            ><strong>{{ categoryToDelete.name }}</strong></em
          ></v-card-text
        >
        <v-col cols="12" sm="8" offset-sm="2">
          <v-text-field
            label="type DELETE below to confirm"
            placeholder="Type DELETE"
            v-model="removeConfirmation"
            variant="outlined"
          ></v-text-field>
        </v-col>
        <v-card-actions class="justify-center pb-4">
          <v-btn
            class="font-weight-bold text-white app-btn"
            color="#a5d867"
            variant="flat"
            :disabled="removeConfirmation != 'DELETE'"
            @click="removeCategory(categoryToDelete)"
            >Yes Delete it!</v-btn
          >
          <v-btn
            color="#592892"
            variant="flat"
            @click="removeCategoryDialog = false"
            >Nevermind</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      color="#592892"
      :timeout="timeout"
      location="top"
      class=""
    >
      <span v-html="snackbarMsg"></span>
      <template #actions="{ attrs }">
        <v-btn
          variant="text"
          v-bind="attrs"
          @click="snackbar = false"
          class="font-weight-bold"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import db from '@/firebase/init'
  import firebase from 'firebase'
  import { mapGetters } from 'vuex'
  import { confirmAction } from '@/components/utilities/SwalService'
  import { currentTheme } from '@/plugins/vuetify'

  export default {
    name: 'Categories',
    props: ['categorybackdoor'],
    data() {
      return {
        snackbar: false,
        snackbarMsg: '',
        timeout: 6000,
        message: '',
        isFormValid: false,
        showedit: false,
        isediting: false,
        allCategories: [],
        allSections: [],
        allUnits: [],
        newCategory: '',
        isloading: true,
        removeCategoryDialog: false,
        categoryToDelete: '',
        removeConfirmation: '',
        isRemovingCategory: false,
        rules: {
          length: (len) => (v) =>
            (v || '').length >= len || `min ${len} characters required `,
          required: (v) => !!v || 'This field is required',
        },
        headers: [
          { text: 'Name', sortable: false, value: 'name' },
          { text: 'Count', sortable: false, value: 'count', align: 'right' },
          {
            text: 'Actions',
            sortable: false,
            value: 'actions',
            align: 'right',
          }, //data-table-expand
        ],
      }
    },
    computed: {
      ...mapGetters('UserData', ['isAuthenticated']),
      isDarkTheme() {
        return currentTheme.value === 'dark'
      },
      isHelpDesk() {
        const roles = this.$store.getters['UserData/getRoles'] || []
        return roles.includes('helpDesk')
      },
    },
    watch: {
      categorybackdoor: function (newVal, oldVal) {
        // watch it
        // console.log('categorybackdoor changed: ', newVal, ' | was: ', oldVal)
        if (newVal > oldVal) {
          this.isloading = true
          this.init()
        }
      },
    },
    methods: {
      addCategory() {
        db.collection('categories')
          .add({
            name: this.newCategory,
          })
          .then(() => {
            // add new categories to the section category array
            this.init()
            // updatedSectionCategory.push({
            //     id: docRef.id,
            // })
          })
      },
      checkAuthorization(permissions) {
        const userRoles = this.$store.getters['UserData/getRoles']
        if (permissions && userRoles) {
          const normalizedPermissions = permissions.includes('superAdmin')
            ? [...permissions, 'helpDesk']
            : permissions

          const hasRole = normalizedPermissions.filter(() =>
            userRoles.some((role) => normalizedPermissions.includes(role))
          )
          return hasRole
        }
      },
      editCat(cat) {
        this.isediting = true
        // console.log('editUser ', cat)
        // Set a timeout for the user experience
        setTimeout(() => {
          db.collection('categories')
            .doc(cat.id)
            .update({
              name: cat.name,
            })
            .then(() => {
              // console.log('complete')
              this.isediting = false
              this.showedit = null
            })
        }, 1000)
      },
      async removeCategory(item) {
        if (this.isHelpDesk) {
          const key = 'categories.deleteNotAllowed'
          const message =
            (this.$te && this.$te(key) ? this.$t(key) : null) ||
            'Help Desk users cannot delete categories.'
          this.snackbar = true
          this.snackbarMsg = message
          return
        }

        if (this.isRemovingCategory) return
        this.isRemovingCategory = true

        if (!item) {
          await confirmAction({
            title: 'Houston we have a problem.',
            text: 'Error with the delete function, missing params.',
            confirmButtonText: 'OK',
            showCancelButton: false,
            context: this,
          })
          this.isRemovingCategory = false
          return
        }

        // 🔄 Remove from `sections`
        const sectionsRef = db
          .collection('sections')
          .where('category', 'array-contains', { id: item.id })
        const sectionSnapshot = await sectionsRef.get()
        sectionSnapshot.forEach((doc) => {
          db.collection('sections')
            .doc(doc.id)
            .update({
              category: firebase.firestore.FieldValue.arrayRemove({
                id: item.id,
              }),
            })
        })

        // 🔄 Remove from `units`
        const unitsRef = db
          .collection('units')
          .where('category', 'array-contains', { id: item.id })
        const unitSnapshot = await unitsRef.get()
        unitSnapshot.forEach((doc) => {
          db.collection('units')
            .doc(doc.id)
            .update({
              category: firebase.firestore.FieldValue.arrayRemove({
                id: item.id,
              }),
            })
        })

        // 🗑 Delete the category
        await db.collection('categories').doc(item.id).delete()

        this.isRemovingCategory = false
        this.removeCategoryDialog = false
        this.snackbar = true
        this.timeout = 3000
        this.snackbarMsg = `Category <strong><i>${item.name}</i></strong> has been deleted.`
        this.init()
      },
      removeCategoryDialogInit(item) {
        if (this.isHelpDesk) {
          const key = 'categories.deleteNotAllowed'
          const message =
            (this.$te && this.$te(key) ? this.$t(key) : null) ||
            'Help Desk users cannot delete categories.'
          this.snackbar = true
          this.snackbarMsg = message
          return
        }

        this.removeCategoryDialog = true
        this.removeConfirmation = ''
        this.categoryToDelete = item
      },
      init() {
        this.allCategories = []
        this.allSections = []
        this.allUnits = []
        this.isloading = true

        setTimeout(() => {
          let catRef = db.collection('categories')
          catRef
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                let cat = doc.data()
                cat.id = doc.id
                this.allCategories.push(cat)
              })
            })
            .then(() => {
              let secRef = db.collection('sections')
              secRef.get().then((snapshot) => {
                snapshot.forEach((doc) => {
                  let sec = doc.data()
                  sec.id = doc.id
                  this.allSections.push(sec)
                })
              })
            })
            .then(() => {
              let unitRef = db.collection('units')
              unitRef.get().then((snapshot) => {
                snapshot.forEach((doc) => {
                  let unit = doc.data()
                  unit.id = doc.id
                  this.allUnits.push(unit)
                })
              })
            })
            .then(() => {
              this.isloading = false
            })
        }, 1000)
      },
      sectionsAndUnitsUsingThisCat(item) {
        // Count the number of categories for each section
        const sectCount = this.allSections.filter((section) =>
          section.category.find((cat) => cat.id == item.id)
        ).length
        // Count the number of categories for each unit
        const unitCount = this.allUnits.filter((unit) =>
          unit.category.find((cat) => cat.id == item.id)
        ).length
        // Add the two together
        return sectCount + unitCount
      },
    },
    created() {
      this.init()
    },
  }
</script>

<style>
  .category-container .v-card {
    transition: opacity 0.4s ease-in-out;
  }
  .category-container .v-image.on-hover .v-image__image {
    filter: blur(0px) grayscale(80%);
    opacity: 4;
  }
  .category-container .action-btns {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    background: radial-gradient(
      circle,
      rgba(0, 0, 0, 0.542454481792717) 0%,
      rgba(0, 0, 0, 0.9037990196078431) 100%
    );
    transition: opacity 0.4s ease-in-out;
  }
  .category-container .action-btns:not(.on-hover) {
    opacity: 0;
  }
  .category-container .show-btns {
    opacity: 1 !important;
  }
  .category-container svg path.a {
    fill: #fff !important;
  }
</style>
